// extracted by mini-css-extract-plugin
export var csatScore = "_n2-5";
export var header = "_n2-1";
export var panelWrapper = "_n2-2";
export var postPreview = "_n2-3";
export var rightContent = "_n2-0";
export var wrappingText = "_n2-4";